import * as actionTypes from './actionTypes';

export const addUser = (id, token, gid, fid, eml) =>({
    type:actionTypes.ADD_USER,
    payload:{
        id: id,
        token: token,
        gmailId:gid,
        facebookId:fid,
        email:eml
    }
});

export const logoutUser = () =>({
    type:actionTypes.LOGOUT_USER
});

export const upCount = (myCount) =>({
    type:actionTypes.UPDATE_COUNT,
    payload:{
        count: myCount
    }
});

export const finCount = (myCount) =>({
    type:actionTypes.FINAL_COUNT,
    payload:{
        count: myCount
    }
});

export const setOtp = (otp, currentTime, username) => ({
    type:actionTypes.SET_OTP,
    payload:{
        otp: otp,
        currentTime: currentTime,
        username: username
    }
});

export const resetOtp = () => ({
    type:actionTypes.RESET_OTP
    
});